<template>
    <div class="container-page pt-10 pb-16 md:pt-16 md:pb-24">
        <div class="grid items-center gap-10 md:grid-cols-[1.15fr_1fr] md:gap-16">
            <div class="order-2 md:order-1">
                <p class="text-[15px] text-muted">Hi! Welcome to my portfolio</p>
                <h1 class="mt-3 font-display text-[48px] font-semibold leading-[1.02] tracking-[-0.035em] text-ink sm:text-[64px] lg:text-[72px]">
                    Ege Arslan
                </h1>
                <p class="mt-3 font-display text-[22px] font-medium text-accent sm:text-[24px]">Software Engineer</p>

                <p class="mt-6 max-w-[520px] prose-body text-[17.5px]">
                    Building real-time systems, microservices and scalable backend architecture.
                </p>

                <div class="mt-8 flex flex-wrap items-center gap-3">
                    <a href="mailto:ege.arslan.dev@gmail.com" class="btn-primary">
                        <i class="fa-solid fa-envelope text-[13px]"></i>
                        Get in touch
                    </a>
                    <router-link to="/projects" class="btn-ghost">
                        View projects
                        <i class="fa-solid fa-arrow-right text-[12px]"></i>
                    </router-link>
                </div>

                <div class="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-[14.5px] text-ink-2">
                    <a v-for="item in contacts" :key="item.label" :href="item.href"
                        :target="item.external ? '_blank' : undefined" rel="noopener noreferrer"
                        class="inline-flex items-center gap-2 hover:text-accent transition-colors">
                        <i :class="item.icon" class="text-muted"></i>
                        {{ item.value }}
                    </a>
                </div>
            </div>

            <div class="order-1 md:order-2 flex justify-start md:justify-end">
                <img src="/images/ege.webp" alt="Ege Arslan" width="601" height="554"
                    class="aspect-[601/554] w-full max-w-[260px] rounded-[28px] object-cover shadow-soft sm:max-w-[340px] md:max-w-[440px]" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            contacts: [
                { label: 'Email', value: 'ege.arslan.dev@gmail.com', href: 'mailto:ege.arslan.dev@gmail.com', icon: 'fa-regular fa-envelope' },
                { label: 'GitHub', value: 'ArslanEge', href: 'https://github.com/ArslanEge', icon: 'fa-brands fa-github', external: true },
                { label: 'LinkedIn', value: 'ege-arslan', href: 'https://www.linkedin.com/in/ege-arslan-981729243/', icon: 'fa-brands fa-linkedin', external: true }
            ]
        };
    }
};
</script>
